import { useTranslation } from 'react-i18next';
import { NumberOfCallsSelectBox } from 'components/molecules/number-of-calls-select-box';

import s from './styles.module.scss';

import type { TTablePrefix } from 'infrastructure/interfaces';
import type { FC } from 'react';
import type { INumberOfCallsItem } from 'infrastructure/data-sources/number-of-calls';

interface NumberOfCallSelectBoxProps {
  cyPrefix?: string;
  tablePrefix: TTablePrefix;
  value?: INumberOfCallsItem['id'];
  updateFilter: <T>(newFilter: Partial<T>) => void;
}
export const NumberOfCallSelectBox: FC<NumberOfCallSelectBoxProps> = ({
  cyPrefix,
  value,
  tablePrefix,
  updateFilter,
}) => {
  const { t } = useTranslation();
  const dataCy = `${cyPrefix}-select-calls`;

  return (
    <div className={s['select-wrapper-calls']}>
      <div className={s['select-label']}>
        <div className={s['select-title']}>
          {t('labels.numberOfCallsSinceEnrolled')}:
        </div>
        <NumberOfCallsSelectBox
          value={value}
          maxWidth="450px"
          minWidth="100px"
          dataCy={dataCy}
          onChange={(v) => {
            updateFilter({
              [`${tablePrefix}numberOfCalls`]: v === null ? v : String(v),
              [`${tablePrefix}page`]: undefined,
            });
          }}
          allowClear
          withNone
        />
      </div>
    </div>
  );
};
